export default __webpack_public_path__ + "static/media/480_store05-es-web.c3d179ce.png";